// phone-input
(function() {

	$('#phone-number').mask('+7 (999) 999-99-99');

})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/phone-input/phone-input.js